(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atable-black-friday-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atable-countdown')) {
  customElements.define('atable-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.endsAt);
      const update = () => {
        let remaining = Math.max(0, end - Date.now());
        const units = { days: 86400000, hours: 3600000, minutes: 60000, seconds: 1000 };
        Object.entries(units).forEach(([unit, size]) => {
          const value = Math.floor(remaining / size);
          remaining %= size;
          const output = this.querySelector(`[data-countdown-${unit}]`);
          if (output) output.textContent = unit === 'days' ? String(value) : String(value).padStart(2, '0');
        });
        if (end <= Date.now()) this.setAttribute('aria-label', 'Black Friday has ended');
      };
      update(); this.timer = window.setInterval(update, 1000);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atable-black-friday-hub-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atable-countdown')) {
  customElements.define('atable-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.endsAt);
      const update = () => {
        let remaining = Math.max(0, end - Date.now());
        const units = { days: 86400000, hours: 3600000, minutes: 60000, seconds: 1000 };
        Object.entries(units).forEach(([unit, size]) => {
          const value = Math.floor(remaining / size);
          remaining %= size;
          const output = this.querySelector(`[data-countdown-${unit}]`);
          if (output) output.textContent = unit === 'days' ? String(value) : String(value).padStart(2, '0');
        });
        if (end <= Date.now()) this.setAttribute('aria-label', 'Black Friday has ended');
      };
      update();
      this.timer = window.setInterval(update, 1000);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
  });
}
document.querySelectorAll('.bf-offer-card[data-card-url]').forEach(card => {
  if (card.dataset.cardReady) return;
  card.dataset.cardReady = 'true';
  card.addEventListener('click', event => {
    if (event.target.closest('a,button,form')) return;
    window.location.href = card.dataset.cardUrl;
  });
  card.addEventListener('keydown', event => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target === card) {
      event.preventDefault();
      window.location.href = card.dataset.cardUrl;
    }
  });
});
document.querySelectorAll('[data-card-buy]').forEach(button => {
  if (button.dataset.buyReady) return;
  button.dataset.buyReady = 'true';
  button.addEventListener('click', async () => {
    const card = button.closest('.bf-offer-card');
    const status = card?.querySelector('[data-card-status]');
    button.disabled = true;
    if (status) status.textContent = 'Adding to checkout…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }) });
      if (!response.ok) throw new Error('This item could not be added right now.');
      window.location.assign(`${root}checkout`);
    } catch (error) {
      if (status) status.textContent = error.message || 'Please try again or open the offer page.';
      button.disabled = false;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atable-black-friday-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atable-countdown')) {
  customElements.define('atable-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.endsAt);
      const update = () => {
        const remaining = Math.max(0, end - Date.now());
        const units = { days: 86400000, hours: 3600000, minutes: 60000, seconds: 1000 };
        let rest = remaining;
        Object.entries(units).forEach(([unit, size]) => {
          const value = Math.floor(rest / size);
          rest %= size;
          const output = this.querySelector(`[data-countdown-${unit}]`);
          if (output) output.textContent = unit === 'days' ? String(value) : String(value).padStart(2, '0');
        });
        if (remaining === 0) this.setAttribute('aria-label', 'Black Friday has ended');
      };
      update();
      this.timer = window.setInterval(update, 1000);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atable-black-friday-offer-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bf-gallery]').forEach(gallery => {
  if (gallery.dataset.ready) return;
  gallery.dataset.ready = 'true';
  const stage = gallery.querySelector('[data-bf-stage]');
  const slides = [...gallery.querySelectorAll('[data-bf-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-bf-thumb]')];
  const dialog = gallery.querySelector('[data-bf-lightbox]');
  const dialogImage = gallery.querySelector('[data-bf-lightbox-image]');
  thumbs.forEach(thumb => thumb.addEventListener('click', () => {
    const slide = slides.find(item => item.dataset.mediaId === thumb.dataset.bfThumb);
    slide?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
  }));
  const updateThumbs = () => {
    const stageBox = stage.getBoundingClientRect();
    let closest = null; let distance = Infinity;
    slides.forEach(slide => { const current = Math.abs(slide.getBoundingClientRect().left - stageBox.left); if (current < distance) { distance = current; closest = slide; } });
    slides.forEach(slide => slide.setAttribute('aria-current', String(slide === closest)));
    thumbs.forEach(thumb => thumb.setAttribute('aria-current', String(thumb.dataset.bfThumb === closest?.dataset.mediaId)));
  };
  stage?.addEventListener('scroll', updateThumbs, { passive: true });
  stage?.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { const index = slides.findIndex(slide => slide.getAttribute('aria-current') === 'true'); const next = slides[Math.max(0, Math.min(slides.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)))]; next?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', inline:'start', block:'nearest' }); } });
  gallery.querySelectorAll('[data-bf-zoom]').forEach(button => button.addEventListener('click', () => { const image = button.querySelector('img'); if (!image || !dialog || !dialogImage) return; dialogImage.src = image.currentSrc || image.src; dialogImage.alt = image.alt; dialog.showModal(); }));
  gallery.querySelector('[data-bf-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
});
document.querySelectorAll('.bf-offer-page').forEach(page => {
  if (page.dataset.buyReady) return;
  page.dataset.buyReady = 'true';
  const form = page.querySelector('[data-bf-form]');
  const variantSelect = page.querySelector('[data-bf-variant]');
  const variantInput = page.querySelector('[data-bf-variant-id]');
  const price = page.querySelector('[data-bf-price]');
  const compare = page.querySelector('[data-bf-compare]');
  const saving = page.querySelector('[data-bf-saving]');
  const stickyPrice = page.querySelector('[data-bf-sticky-price]');
  const status = page.querySelector('[data-bf-status]');
  const updateVariant = option => {
    if (!option) return;
    if (variantInput) variantInput.value = option.value;
    if (price) price.textContent = option.dataset.price || '';
    if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !(Number(option.dataset.percent) > 0); }
    if (saving) { saving.textContent = Number(option.dataset.percent) > 0 ? `Save ${option.dataset.saving} · ${option.dataset.percent}% off` : ''; saving.hidden = !(Number(option.dataset.percent) > 0); }
    const available = option.dataset.available === 'true';
    page.querySelectorAll('[data-bf-buy-now],.bf-offer__add').forEach(button => { button.disabled = !available; });
    page.querySelector('.bf-offer__sold-out')?.toggleAttribute('hidden', available);
  };
  variantSelect?.addEventListener('change', () => updateVariant(variantSelect.selectedOptions[0]));
  page.querySelectorAll('[data-bf-buy-now]').forEach(button => button.addEventListener('click', async () => {
    const id = variantInput?.value || page.querySelector('[data-bf-single-variant]')?.value;
    if (!id || !form || button.disabled) return;
    page.querySelectorAll('[data-bf-buy-now]').forEach(item => { item.disabled = true; });
    if (status) status.textContent = 'Adding to checkout…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[{id:Number(id),quantity:1}]}) });
      if (!response.ok) { const result = await response.json().catch(() => ({})); throw new Error(result.description || 'This item could not be added right now.'); }
      window.location.assign(`${root}checkout`);
    } catch (error) {
      if (status) status.textContent = error.message || 'Please try again or add the item to your cart.';
      page.querySelectorAll('[data-bf-buy-now]').forEach(item => { item.disabled = false; });
    }
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atable-hero"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('atable-hero-motion')) {
    customElements.define('atable-hero-motion', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.stage = this.querySelector('.atable-hero__stage');
        this.button = this.querySelector('.atable-hero__motion-toggle');
        this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
        this.pointer = matchMedia('(hover: hover) and (pointer: fine)');
        const nesting = this.querySelector('.atable-sun-motion');
        if (nesting) {
          Promise.all([...nesting.querySelectorAll('img')].map(image => image.decode()))
            .then(() => { if (this.isConnected) nesting.parentElement.dataset.nestingReady = ''; })
            .catch(() => {});
        }
        this.current = [0, 0]; this.target = [0, 0]; this.paused = false; this.visible = false;
        this.sync = () => {
          const running = !this.reduce.matches && !this.paused && this.visible && !document.hidden;
          this.dataset.motion = running ? 'running' : 'paused';
          if (this.button) this.button.hidden = this.reduce.matches || !this.querySelector('.atable-hero__object');
          if (!running) {
            cancelAnimationFrame(this.frame); this.frame = 0; this.current = [0, 0]; this.target = [0, 0];
            this.stage.style.removeProperty('--atable-tilt-x'); this.stage.style.removeProperty('--atable-tilt-y');
          }
        };
        this.tick = () => {
          this.frame = 0;
          if (this.dataset.motion !== 'running') return;
          this.current = this.current.map((v, i) => v + (this.target[i] - v) * .09);
          this.stage.style.setProperty('--atable-tilt-x', this.current[0].toFixed(3) + 'deg');
          this.stage.style.setProperty('--atable-tilt-y', this.current[1].toFixed(3) + 'deg');
          if (this.current.some((v, i) => Math.abs(this.target[i] - v) > .008)) this.frame = requestAnimationFrame(this.tick);
        };
        this.aim = (x, y) => { this.target = [x, y]; if (!this.frame && this.dataset.motion === 'running') this.frame = requestAnimationFrame(this.tick); };
        this.stage.addEventListener('pointermove', (event) => {
          if (!this.pointer.matches || this.dataset.motion !== 'running' || event.pointerType === 'touch') return;
          const rect = this.stage.getBoundingClientRect();
          this.aim(((event.clientY - rect.top) / rect.height - .5) * -3, ((event.clientX - rect.left) / rect.width - .5) * 5);
        }, options);
        this.stage.addEventListener('pointerleave', () => this.aim(0, 0), options);
        this.button?.addEventListener('click', () => { this.paused = !this.paused; this.button.setAttribute('aria-pressed', String(this.paused)); this.sync(); }, options);
        this.reduce.addEventListener('change', this.sync, options);
        document.addEventListener('visibilitychange', this.sync, options);
        this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.sync(); });
        this.observer.observe(this); this.sync();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
    });
  }
  const revealMedia = matchMedia('(prefers-reduced-motion: reduce)');
  const revealObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.remove('atable-reveal-pending'); revealObserver.unobserve(entry.target); } });
  }, { threshold: .08 });
  const revealItems = (scope = document) => {
    scope.querySelectorAll('[data-atable-reveal-item]').forEach(item => {
      if (revealMedia.matches || item.getBoundingClientRect().top < innerHeight) return;
      item.classList.add('atable-reveal-pending'); revealObserver.observe(item);
    });
  };
  revealItems();
  document.addEventListener('shopify:section:load', event => revealItems(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-atable-reveal-item]').forEach(item => revealObserver.unobserve(item)));
  document.addEventListener('shopify:block:select', event => { event.target.classList.remove('atable-reveal-pending'); revealObserver.unobserve(event.target); });
  revealMedia.addEventListener('change', () => { if (revealMedia.matches) { revealObserver.disconnect(); document.querySelectorAll('.atable-reveal-pending').forEach(item => item.classList.remove('atable-reveal-pending')); } });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atable-offer-detail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atable-offer-card')) {
  customElements.define('atable-offer-card', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.querySelector('form').addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = event.currentTarget, submitter = event.submitter || form.querySelector('button[type="submit"]'), buttons = [...form.querySelectorAll('button[type="submit"]')], error = form.querySelector('[role="alert"]');
        if (submitter.disabled) return;
        buttons.forEach((button) => { button.disabled = true; }); submitter.setAttribute('aria-busy', 'true'); error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Please check availability and review your cart before trying again.');
          window.location.assign(submitter.dataset.buyNow === 'true' ? this.dataset.checkoutUrl : this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || 'Please check your connection and review your cart before trying again.';
          error.hidden = false; buttons.forEach((button) => { button.disabled = false; }); submitter.removeAttribute('aria-busy');
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atable-offer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atable-pair-offer')) {
  customElements.define('atable-pair-offer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.querySelector('form').addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const button = form.querySelector('button');
        const error = form.querySelector('[role="alert"]');
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'We could not add the pair. Please check availability and try again.');
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || 'Please check your connection and review your cart before trying again.';
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atable-offers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atable-offer-card')) {
  customElements.define('atable-offer-card', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.querySelector('form').addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = event.currentTarget, button = form.querySelector('button'), error = form.querySelector('[role="alert"]');
        if (button.disabled) return;
        button.disabled = true; button.setAttribute('aria-busy', 'true'); error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Please check availability and review your cart before trying again.');
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || 'Please check your connection and review your cart before trying again.';
          error.hidden = false; button.disabled = false; button.removeAttribute('aria-busy');
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('atable-countdown')) {
  customElements.define('atable-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.endsAt);
      const update = () => {
        let remaining = Math.max(0, end - Date.now());
        const units = { days: 86400000, hours: 3600000, minutes: 60000, seconds: 1000 };
        Object.entries(units).forEach(([unit, size]) => {
          const value = Math.floor(remaining / size);
          remaining %= size;
          const output = this.querySelector(`[data-countdown-${unit}]`);
          if (output) output.textContent = unit === 'days' ? String(value) : String(value).padStart(2, '0');
        });
        if (end <= Date.now()) this.setAttribute('aria-label', 'Black Friday has ended');
      };
      update();
      this.timer = window.setInterval(update, 1000);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
  });
}
(() => {
  const measureCampaignBar = () => {
    const bar = document.querySelector('.atable-campaign-bar');
    document.documentElement.style.setProperty('--bf-bar-height', `${bar ? Math.ceil(bar.getBoundingClientRect().height) : 0}px`);
  };
  window.atableCampaignBarResize?.disconnect?.();
  measureCampaignBar();
  const bar = document.querySelector('.atable-campaign-bar');
  if (bar && 'ResizeObserver' in window) {
    window.atableCampaignBarResize = new ResizeObserver(measureCampaignBar);
    window.atableCampaignBarResize.observe(bar);
  }
  window.removeEventListener('resize', window.atableCampaignBarResizeHandler);
  window.atableCampaignBarResizeHandler = measureCampaignBar;
  window.addEventListener('resize', window.atableCampaignBarResizeHandler, { passive: true });
  window.addEventListener('load', measureCampaignBar, { once: true });
})();
document.addEventListener('click', (event) => {
  const link = event.target.closest('.atable-mobile-menu a');
  if (link) link.closest('details').open = false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.querySelectorAll('.atable-product__form').forEach(form=>{
 const availability=form.closest('.atable-product__sticky')?.querySelector('.atable-availability');
 if(!availability)return;
 const update=()=>{const message=availability.querySelector('[data-order-message]');const byOrder=availability.dataset.byOrder==='true'&&Number(form.elements.quantity.value)>Number(availability.dataset.stock);if(message)message.hidden=!byOrder;const delivery=form.elements.namedItem('properties[Delivery]');if(delivery)delivery.value=byOrder?'Made to order · Expected delivery: 24–30 days':form.querySelector('input[name="id"]')?.value==='50439299956839'?'In stock · Expected delivery: 3–5 days':'In stock · Expected delivery: 5–7 days';};
 form.addEventListener('input',update);form.addEventListener('change',update);update();
});

  } catch(e) { console.error(e); }
})();
})();
